import { ConnectProto } from "@racoon/api";
import { ALL_LOCATION_TYPES } from "~/shared/api/locations/locations.grpc";

/**
 * A route can unload at any kind of facility — depot, polygon, sorting complex,
 * transfer station — so the picker offers all of them. Suspicious locations are
 * flagged spots, not places a truck is ever sent to, hence the one exclusion.
 */
const UNLOAD_LOCATION_TYPES = ALL_LOCATION_TYPES.filter(
  (type) => type !== ConnectProto.LocationType.SUSPICIOUS,
);
/** The request behind the unload picker — shared, so a caller can have it loaded first. */
export const unloadLocationsArgs = (orgId: bigint) => ({
  ownerOrganizationIds: [orgId],
  types: UNLOAD_LOCATION_TYPES,
});
